
/* work order needs: 
  @portfolioid          AS portfolioid,
	  @building             AS building,
	  @unitId               AS unitId,
	  @reported_location    AS reported_location,
	  @job_loc_id           AS job_loc_id,
	  @units_reason_req     AS units_reason_req,
	  @work_order_type      AS work_order_type,
	  @regional_office      AS regional_office,
	  @units_grade_name     AS units_grade_name,
	  @jeed_code            AS jeed_code,
	  @units_property_code  AS units_property_code,
	  @job_name             AS job_name;
	  */
export type NumericStringMap = {
	[key: number]: string;
};

export type TenantView = {
	Tenant_id: number;
	Email: string;
	First_name: string;
	Last_name: string;
	Phone: string;
	Unit_id: number;
	Last_login: Date;
	Language: number;
	Building_name: string;
	Building_id: number;
	Address: string;
	Unit_number: string;
	Portfolio_id: number;
	Region: string;
	City: string;
	Street_address: string;
	Google_map: string;
}

export type TenantWorkOrderRequest = {
	Work_request_id: number;
	Tenant_id: number;
	Building_id: number;
	Unit_id: number;
	Portfolio_id: number;
	Work_order_type_id: number;
	Job_location_id: number;
	Reason_for_request_id: number;
	Reported_location_id: number;
	Emergency: boolean;
	Last_name: string;
	Street_address: string;
	City: string;
	Region: string;
	Job_location_name_e: string;
	Job_location_name_j: string;
	Job_location_name: string;
	Reason_for_request_name: string;
	Reported_location_name: string;
	Description: string;
	Work_request_status: string;
	Work_request_status_name_en: string;
	Work_request_status_name_jp: string;
	Work_request_status_name: string;
	Work_order_id: number;
	Created_at: Date;
	Updated_at: Date;
	Work_request_status_description_en: string;
	Work_request_status_description_jp: string;
	Work_request_status_description: string;
	
}

export type WorkOrderFile = {
	File_id: number;
	Work_request_id: number;
	File_name: string;
	S3_file_name: string;
	uploaded_at: Date;
}

export type RequestListItem = {
	Request: TenantWorkOrderRequest;
	Files: WorkOrderFile[];
}

export function makeBlankTenantView(): TenantView {
	return {
		Tenant_id: 0,
		Email: '',
		First_name: '',
		Last_name: '',
		Phone: '',
		Unit_id: 0,
		Last_login: new Date(),
		Language: 2,
		Building_name: '',
		Building_id: 0,
		Address: '',
		Unit_number: '',
		Portfolio_id: 0,
		Region: '',
		City: '',
		Street_address: '',
		Google_map: ''
	}
}

export function makeNewRequest( tenant_view: TenantView ): TenantWorkOrderRequest {
	return {
		Work_request_id: 0,
		Tenant_id: tenant_view.Tenant_id,
		Building_id: tenant_view.Building_id,
		Unit_id: tenant_view.Unit_id,
		Portfolio_id: tenant_view.Portfolio_id,
		Work_order_type_id: 1,
		Job_location_id: 0,
		Reason_for_request_id: 0,
		Emergency: false,
		Last_name: '',
		Street_address: '',
		City: '',
		Region: '',
		Job_location_name: '',
		Job_location_name_e: '',
		Job_location_name_j: '',
		Reason_for_request_name: '',
		Reported_location_id: 0,
		Reported_location_name: '',
		Description: '',
		Work_request_status: '',
		Work_request_status_name_en: '',
		Work_request_status_name_jp: '',
		Work_request_status_name: '',
		Work_order_id: 0,
		Created_at: {} as Date,
		Updated_at: {} as Date,
		Work_request_status_description_en: '',
		Work_request_status_description_jp: '',
		Work_request_status_description: '',

	};
}


//work order reported location : db job_location
export type JobLocation = {
	id: number;
	location_code: string;
	location_name_e: string;
	location_name_j: string;
	added_on: number;
	added_by: number;
	updated_on: Date;
	updated_by: number;
	module_name: string;
	reported_location: number;
	notes: string;
	fixed_asset_type_flag: boolean;
	location_status: boolean;
	LABEL: string;
};


//reason for request : from db: reason_request_view
export type ReasonRequest = {
	id: number;
	opt_name: string;
	opt_namej: string;
	opt_flag: string;
	LABEL: string;
}

//repoetd location : from db: reported_location_view
export type ReportedLocation = {
	id: number;
	opt_name: string;
	opt_namej: string;
	opt_flag: string;
	LABEL: string;
}


//work order types: from db: work_order_type. we will just hardcode these to 1. tenant req will always be 1
/*
1	Single Property	シングル物件	1	7/12/2019 6:34:54 PM
2	Multiple Property	複数物件	1	7/12/2019 6:34:54 PM

id int NOT NULL AUTO_INCREMENT,
type_name varchar(100) DEFAULT NULL,
type_namej varchar(255) DEFAULT NULL,
status tinyint NOT NULL DEFAULT 1,
added_on timestamp NOT NULL DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
*/
export type WorkOrderType = {
	id: number;
	type_name: string;
	type_namej: string;
	status: number;
	added_on: Date;
}
